import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, List,Icon, ListItemButton, ListItemIcon, ListItemText, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react"
import 'material-icons/iconfont/material-icons.css';
import { Link, useLocation } from 'react-router-dom'
import Text from "../../genericComponents/Text";
const GroupMenuItem = ({ item, depth,onClose, swapMenuWidth }) => {
    
    const location=useLocation();
    const menuItemdepth = depth ? depth : 0;
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };    
    const theme=useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))        
    const extraProps = !item.children ? { component: Link, to: item.path,selected:decodeURI(location.pathname).startsWith(item.path) } : {};
    let buttonStyle=null;
    let iconStyle=null;
    let textStyle=null;
    if(isXs){        
        buttonStyle={paddingLeft:((menuItemdepth)*56)+24+"px"}            
    }else if(swapMenuWidth){

    }else{
        iconStyle={minWidth:48}
        if(menuItemdepth!==0){            
            buttonStyle={paddingLeft:((menuItemdepth-1)*48)+64+"px"}
        }
    }    
    return (<><ListItemButton
        {...extraProps}    
        sx={buttonStyle} onClick={item.children?handleClick:onClose}>
        <ListItemIcon sx={iconStyle}>
                     <Icon>{item.icon.toLowerCase()}</Icon>   
        </ListItemIcon>
        <ListItemText sx={textStyle} primary={<Text text={!swapMenuWidth ? item.text : "-"} />} />
        {item.children ? open ? <ExpandLess /> : <ExpandMore /> : null}

    </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                {!item.children ? null : item.children.map((menuItem, i) => <GroupMenuItem onClose={onClose}  swapMenuWidth={swapMenuWidth} key={menuItemdepth + 1 + i} depth={menuItemdepth + 1} item={menuItem} />
                )}</List>

        </Collapse></>)
}
export default GroupMenuItem